import './RadioButton.css';

import { useDefaultOptionValue } from '../../hooks/useDefaultOptionValue';
import {
  RadioButton as PrimeRadioButton,
  RadioButtonChangeEvent,
} from 'primereact/radiobutton';
import clsx from 'clsx';
import InputErrorMessage from '../../../InputErrorMessage/InputErrorMessage';
import type { GridInputBaseProps } from '../../types';
import {
  ControlItemValue,
  StaticControlItem,
} from '../../../../../types/types';

type RadioButtonProps = Omit<GridInputBaseProps<ControlItemValue>, 'value'> & {
  value: ControlItemValue | null;
  options?: StaticControlItem[];
  defaultValue?: ControlItemValue;
};

const RadioButton = ({
  onChange,
  onTouch,
  onFocusIn,
  onFocusOut,
  value,
  name,
  error,
  setError,
  disabled,
  options = [],
  defaultValue,
  isColumnFilter,
}: RadioButtonProps) => {
  const handleOnchange = (e: RadioButtonChangeEvent) => {
    const submitValue: ControlItemValue = e.value;
    onChange(submitValue);
    onTouch?.(submitValue);

    if (submitValue !== null) {
      setError(null);
    }
  };

  const handleOnBlur = () => {
    if (error === null) {
      setError(null);
    }
    onFocusOut?.();
  };

  useDefaultOptionValue(options, value, defaultValue, onChange, isColumnFilter);

  return (
    <div
      className="radio-button-container"
      onFocus={onFocusIn}
      onBlur={handleOnBlur}
    >
      {options.map((option, index) => (
        <div
          key={`${String(option.value)}_${index}`}
          className={clsx(
            'radio-button-item',
            option.value === value && 'radio-button-item-checked'
          )}
        >
          <PrimeRadioButton
            inputId={`${name}-${option.value}`}
            name={name}
            value={option.value}
            checked={option.value === value}
            onChange={handleOnchange}
            disabled={disabled}
            invalid={!!error}
          />
          <label
            htmlFor={`${name}-${option.value}`}
            className="radio-button-label"
          >
            {option.label}
          </label>
        </div>
      ))}
      <InputErrorMessage error={error} />
    </div>
  );
};

export default RadioButton;
